import React, { Component } from "react";
import {Badge, Glyphicon, OverlayTrigger} from 'react-bootstrap';
import { ProjectService } from "../Services/ProjectService";
import { JobActionService } from "../Services/JobActionService";
import { ItemService } from "../Services/ItemService";
import {tooltip, toInt, getTimeInIST, format_display, getProjectStatusBadge, convertProjectStatusToString} from '../Utils';
import {ROLES} from '../Roles';
import XLSX from 'xlsx';
import Paper from '@material-ui/core/Paper';
import EnhancedTableHead from '../components/EnhancedTableHead';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { RowCountOptions } from "../Config";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Slide from '@material-ui/core/Slide';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
// import HelpIcon from '@material-ui/icons/Help';
import AutoCompleteSelection from '../components/AutoCompleteSelection';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const styles = theme =>({
    fab: {
        margin: theme.spacing.unit,
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
    root: {
      width: '100%',
      marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      paddingTop : theme.spacing.unit, 
      paddingLeft: theme.spacing.unit, 
      paddingRight: theme.spacing.unit,
      paddingBottom: theme.spacing.unit
    },
    tablecell: {
        fontSize: '40pt',
        padding: '5px'
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        width: "80%",
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    table: {
        minWidth: 700
    },
    list: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px'
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "30%",
        },
        right: "22px"
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    }
  });

class Project extends Component {

    constructor(props) {
      super(props);
      this.state = {
        data: [],
        originalData: [],
        current_rows: [],
        numItemsPerPage: 10,
        currentPageNumber: 0,
        totalItems: 0,
        totalPages: 0,
        filter: '',
        new_project: {id: undefined, name: "", description: "", qty: "", status: "1", created_date: "", created_by: "", modified_date: "", items:  [], job_actions: []},
        show: false,
        showItemsDialog: false,
        item_dialog_details: [],
        columns : [
            { id: 'name', numeric: false, disablePadding: true, label: 'Name', sortable: true },
            // { id: 'description', numeric: false, disablePadding: false, label: 'Description' , sortable: true },
            { id: 'qty', numeric: true, disablePadding: true, label: 'Quantity' , sortable: true },
            { id: 'status', numeric: false, disablePadding: true, label: 'Status', sortable: true  },
            { id: 'items', numeric: false, disablePadding: true, label: 'Items Used', sortable: false  },
            { id: 'job_actions', numeric: false, disablePadding: true, label: 'Job Phases' , sortable: false },
            { id: 'created_date', numeric: false, disablePadding: true, label: 'Start Date', sortable: true  },
            { id: 'created_by', numeric: false, disablePadding: true, label: 'Created By', sortable: true  },
            // { id: 'transaction', numeric: false, disablePadding: false, label: 'Transactions', sortable: false  },
            { id: 'actions', numeric: false, disablePadding: true, label: '' , sortable: false },
        ],
        order: 'asc',
        orderBy: 'name',
        message : '',
        master_job_actions: [],
        master_items: [],
        item_rows: [],
        showAddItem: false,
        showChangeStatus: false,
        selected_project: { status: "0"},
        error_fields: {name : false, description: false, qty: false, job_actions: false, items: false}
      }

      this.handleSelect = this.handleSelect.bind(this);
      this.clearSearch = this.clearSearch.bind(this);

      this.handleShow = this.handleShow.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.newProject = this.newProject.bind(this);
      this.createModifyproject = this.createModifyproject.bind(this);
      this.removeProject = this.removeProject.bind(this);
      
      this.handleCloseItemsDialog = this.handleCloseItemsDialog.bind(this);
      this.handleShowItemsDialog = this.handleShowItemsDialog.bind(this);
    
      // Export
      this.export = this.export.bind(this);

      //Sort
      this.sortBy = this.sortBy.bind(this);
    }

    componentWillMount(){
        this.props.setTitle('Projects');
        this.props.isLoading(true);
        ProjectService.getTotalCount(false)
        .then((data) => {
            this.setState({
                totalItems: toInt(data.count), 
                totalPages: Math.ceil(data.count / this.state.numItemsPerPage) - 1
            });
            this.fetchItems();
            this.fetchJobActions();
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    fetchJobActions(){
        JobActionService.getJobActions()
        .then((data) => {
            let m = [];
            data.job_actions.forEach(element => {
                m.push({id: element.id, name: element.name, value: element.name, label: element.name, status: element.status});
            });
            this.setState({master_job_actions: m});
        })
        .catch((error) =>{
            console.log("Error while fetching Job Actions list");
        });
    }

    fetchItems(){
        ItemService.getItemList()
        .then((data) => {
            console.log(data);
            this.setState({master_items: data.items});
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }
 
    componentDidMount(){
        this.fetchData(0, this.state.numItemsPerPage);
    }

    removeProject(e, project){
        e.preventDefault();
        this.props.showConfirmDialog(`Confirm removal of ${project.name} Project?`, undefined, () =>{
            ProjectService.removeProject(project.id)
            .then((data) => {
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                this.props.closeConfirmDialog();
                this.props.showSnackBar(`Removed Project ${project.name}`, 'success');
            })
            .catch(error => {
                this.props.showSnackBar(`Failed to remove Project ${project.name}. Please try again later.`, 'success');
                console.log(error);
            });
        });
    }

    sortBy = (event, property) => {
        const orderBy = property;
        let order = 'desc';
    
        if (this.state.orderBy === property && this.state.order === 'desc') {
          order = 'asc';
        }
    
        this.setState({ order, orderBy }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangeRowsPerPage = event => {
        this.setState({ numItemsPerPage : event.target.value }, () => this.fetchData(0, this.state.numItemsPerPage, ''));
    }

    handleChangePage = (event, page) => {
        if(this.state.currentPageNumber > page){
            this.fetchRow(this.state.currentPageNumber - 1);
        } else {
            this.fetchRow(this.state.currentPageNumber + 1);
        }
    };

    changeStatus = (event, project) => {
        if(this.props.user.roles.includes(ROLES.ADMIN)){
            this.setState({selected_project: project}, () => this.handleShowChangeStatus());
        }
    }

    changeStatusForProject = (e) => {
        this.props.showConfirmDialog("Confirm change status?", undefined, () => {
            let headers = {user_id : this.props.user.id };
            ProjectService.changeProjectStatus(headers, {id: this.state.selected_project.id, status: e.target.value})
            .then((data) => {
                this.props.showSnackBar(`Changed status of Project`, 'success');
                this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
                this.props.closeConfirmDialog();
                this.handleCloseChangeStatus();
            })
            .catch(error => {
                console.log(error);
                this.props.showSnackBar(`Failed to change status. Please try again.`, 'error');
            });
        });
    }

    fetchData(start, numberItems, filter = ''){
        this.props.isLoading(true);
        let rows = [];
        let sort = this.state.orderBy ? this.state.orderBy : '', direction = this.state.order ? this.state.order : '';
        let statuses = this.state.statuses ? this.state.statuses.join(',') : [0, 1, 2].join(',');
        ProjectService.getProjectList(start, numberItems, filter, statuses, sort, direction)
        .then((data) => {
            console.log(data);
            this.setState({data: data.projects, originalData: data.projects});
            if(data.projects){
                data.projects.forEach((project) => {
                    rows.push(<ProjectDetails key={project.id} project={project} showItemDetails={this.showItemDetails} changeStatus={this.changeStatus} edit={this.newProject} remove={this.removeProject}/>);
                });
                this.setState({
                    current_rows: rows
                });
            }
            
            this.props.isLoading(false);
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }

    handleChange(e) {
        e.preventDefault();
        let {new_project, error_fields} = this.state;
        new_project[e.target.name] = e.target.value;
        error_fields[e.target.name] = false;
        this.setState({new_project: new_project, error_fields: error_fields});
    }

    handleJobActionChange = (job_actions) =>{
        let {new_project, error_fields}  = this.state;
        new_project.job_actions = job_actions.map(value => ({
            job_action_id: value.id,
            job_action_name: value.value,
            status: value.status
            })
        );
        if(new_project.id){
            let deletedJobActions = this.state.originalData.filter(o => o.id === new_project.id)[0].job_actions.filter(p => new_project.job_actions.filter(c => c.job_action_id === p.job_action_id).length === 0);
            deletedJobActions.forEach(element => {
                element.status = "-1";
                new_project.job_actions.push(element);
            });
        }
        error_fields.job_actions = new_project.job_actions.filter(ja => ja.status !== "-1").length === 0 ? true : false;
        this.setState({new_project, error_fields});
    }

    removeItem = (e, item) => {
        if(toInt(item.qty) !== 0){
            this.props.showConfirmDialog("Confirm Remove?", undefined, () => {
                this.confirmRemove(item, this.props.closeConfirmDialog);
            });
        } else {
            this.confirmRemove(item, undefined);
        }
    }

    confirmRemove = (item, callback) => {
        let items = this.state.new_project.items;

        if(!this.state.new_project.id || (this.state.new_project.id && !item.created_date)){
            items = items.filter((i) => i.item_id !== item.item_id);
        } else {
            let i = items.filter((i) => i.item_id === item.item_id)[0];
            i.status = "-1";
        }
        this.setState((prevState) => ({
            new_project: {
                        ...prevState.new_project,
                        items: items
            },
            item_rows: this.updateProjectItemRows(items)
        }), () => callback ? callback() : null);
    }

    handleItemQtyChange = (e) => {
        let i = this.state.new_project.items;
        let item = i.filter((i) => i.item_id === e.target.name);
        if(item.length === 1){
            item[0].qty = e.target.value;
        }
        this.setState((prevState) => ({
            new_project: {
                        ...prevState.new_project,
                        items: i
            }
        }));
    }

    updateProjectItemRows(items){
        return items.filter(i => toInt(i.status) !== -1).map(item => (
            <ItemDetails key={item.item_id} item={item} master_items={this.state.master_items} handleItemQtyChange={this.handleItemQtyChange} removeItem={this.removeItem} classes={this.props.classes}/>
        ));
    }

    newProject(e, project){
        if(project) {
            //Add previous contract values to state and populate the form
            let rows = this.updateProjectItemRows(project.items);
            this.setState({new_project: {id: project.id, name: project.name, description: project.description, qty: project.qty, status: project.status, created_date: project.created_date, created_by: project.created_by, modified_date: project.modified_date, items:  project.items.slice(), job_actions: project.job_actions.slice()}, item_rows: rows});
        }
        this.handleShow();
    }

    handleClose() {
        this.setState({ show: false });
        this.setState({
            new_project: {id: undefined, name: "", description: "", qty: "", status: "1", created_date: "", created_by: "", modified_date: "", items:  [], job_actions: []},
            item_rows: [],
            error_fields: {name : false, description: false, qty: false, job_actions: false, items: false}
        });
    }

    handleShowItemsDialog() {
        this.setState({ showItemsDialog: true });
    }

    handleCloseItemsDialog() {
        this.setState({ showItemsDialog: false });
        this.setState({ item_dialog_details : [] });
    }
    
    handleShow() {
        this.setState({ show: true });
    }

    handleShowAddItemProject = () => {
        this.setState({ showAddItem: true });
    }

    handleCloseAddItemProject = () => {
        this.setState({ showAddItem: false });
    }

    handleShowChangeStatus = () => {
        this.setState({ showChangeStatus: true });
    }

    handleCloseChangeStatus = () => {
        this.setState({ showChangeStatus: false, selected_project: { status: "0"} });
    }

    handleAddItemToProject = (e) => {
        let item = this.state.master_items.filter(i => i.id === e.target.value)[0];
        let error_fields = this.state.error_fields;
        if(item){
            let i = {
                item_id:  item.id,
                item_name: item.name,
                qty: "0",
                status: "1",
                project_id: this.state.new_project.id
            }
            let items = this.state.new_project.items;
            items = items.filter(i => i.item_id !== item.id);
            items.push(i);
            error_fields.items = items.length === 0 ? true : false;
            this.setState((prevState) => ({
                new_project: {
                            ...prevState.new_project,
                            items: items
                },
                error_fields : error_fields,
                item_rows: this.updateProjectItemRows(items)
            }), () => this.handleCloseAddItemProject());
        }
    }

    showItemDetails = (e, project) =>{
        // this.props.showSnackBar(`This feature has not been implemented` , 'info');
        let rows = [];

        project.items.forEach((element, index) => {
            let unit = this.state.master_items.filter(i => i.id === element.item_id)[0].unit_size;
            rows.push(
                <Grid container justify="center" spacing={16} key={index}>
                    <Grid key={1} item xs={6}>
                        <Typography variant="subtitle1" id="modal-title" style={{ lineHeight: '38px', textAlign: 'left'}}>
                            {element.item_name}
                        </Typography>
                    </Grid>
                    <Grid key={2} item xs={6}>
                    <Typography variant="subtitle1" id="modal-title" style={{ lineHeight: '38px', textAlign: 'right'}}>
                            {parseFloat(element.qty)} {unit}
                        </Typography>
                    </Grid>
                </Grid>
            );
        });
        this.setState({item_dialog_details: rows}, () => this.handleShowItemsDialog());
    }

    confirmSave = () => {
        let new_project = this.state.new_project;
        this.props.isLoading(true);

        let headers = {user_id : this.props.user.id };
        ProjectService.createproject(headers, new_project)
        .then((data) => {
            console.log(data);
            this.props.isLoading(false);
            this.handleClose();
            this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
            this.props.closeConfirmDialog();
        })
        .catch(error => {
            this.props.showSnackBar(`Something went wrong. Please try again later.` , 'error');
            this.props.isLoading(false);
        });
    }

    createModifyproject(e){
        e.preventDefault();
        let {new_project, error_fields} = this.state;
        console.log(toInt(new_project.qty));
        if(new_project.name.length && new_project.description.length && toInt(new_project.qty) > 0 && new_project.job_actions.length > 0 && new_project.items.length > 0 && new_project.items.filter(i => toInt(i.qty) === 0).length === 0){
            this.setState({new_project : new_project}, () => this.props.showConfirmDialog("Create project", "Confirm", this.confirmSave));
            return;
        } 
        if(new_project.name.length === 0) {
            error_fields.name = true;
        }
        
        if(new_project.description.length === 0) {
            error_fields.description = true;
            // this.props.showConfirmDialog("Please fill in all the details", undefined, undefined);
        }  
        if((toInt(new_project.qty)|| 0) <= 0) {
            error_fields.qty = true;
            // this.props.showConfirmDialog("Please provide qty", undefined, undefined);
        } 
        if(new_project.job_actions.length === 0){
            error_fields.job_actions = true;
            // this.props.showConfirmDialog("Add atleast one job phase", undefined, undefined);
        } 
        if(new_project.items.length === 0){
            error_fields.items = true;
            this.props.showConfirmDialog("Add atleast one item that would be needed", undefined, undefined);
        } 
        if(new_project.items.filter(i => (toInt(i.qty) || 0) === 0).length !== 0){
            this.props.showConfirmDialog("There are items without any qty in the list. Please remove items that are not needed.", undefined, undefined);
        }

        this.setState({error_fields});
    }

    clearSearch(e){
        this.refs.inputText.value = "";
        this.setState({filter: ''});
        this.fetchData(this.state.currentPageNumber * this.state.numItemsPerPage, this.state.numItemsPerPage);
    }

    filterCriteria(e){
        e.preventDefault();
            const searchText = this.refs.inputText.value;
            this.setState({filter: searchText}, () => this.fetchData(0, this.state.numItemsPerPage, searchText));
    }
    
    handleSelect(eventKey, e) {
        if(eventKey === 'prev'){
            if((this.state.currentPageNumber) > 0){
                this.fetchRow(this.state.currentPageNumber - 1);
            }
        } else if(eventKey === 'next'){
            if((this.state.currentPageNumber) < this.state.totalPages){
                this.fetchRow(this.state.currentPageNumber + 1);
            }
        }
    }

    fetchRow(newCurrentPage){
        this.fetchData(newCurrentPage * this.state.numItemsPerPage, this.state.numItemsPerPage);
        this.setState({ currentPageNumber: newCurrentPage });
    }

    export(e){
        if(e){
            e.preventDefault();
        }

        ProjectService.getprojectListWithContracts(0, this.state.totalItems, true)
        .then((data) => {
            console.log(data);
            let products = this.state.master_contract.map((p) => p.product_name);
            if(data.users){
                let title = ["Sl. No","project", "Manager Name", "Email", "Contact No", "Address", "GST No", "Contract Details" ];
                title.push.apply(title, products);
                let exportprojectData = [title];
                this.props.isLoading(true);
                data.users.forEach((user, index) => {
                    let projectArray = [index + 1, user.project_name, user.name, user.email, user.mobile_no, user.flat, user.gst_no, ''];
                    let contracts = this.state.master_contract.map((p) =>  {
                        let cont = user.contracts.filter((c) => c.product_id === p.product_id );  
                        if(cont.length > 0){
                          return cont[0].commission;
                        } else {
                            return "0";
                        }
                    });
                    projectArray.push.apply(projectArray, contracts);
                    exportprojectData.push(projectArray);
                });
                if(exportprojectData){
                    console.log(exportprojectData);
                    const wb = XLSX.utils.book_new();
                    const wsAll = XLSX.utils.aoa_to_sheet(exportprojectData);
                    XLSX.utils.book_append_sheet(wb, wsAll, 'projects');
                    XLSX.writeFile(wb, "project List.xlsx");
                    this.props.isLoading(false);
                }
            }
        })
        .catch(error => {
            console.log(error);
            this.props.isLoading(false);
        });
    }
    
    render() {
        let {error_fields, message} = this.state;
        const { classes } = this.props;
        return (
            <div className="Home">
                <h3>Projects: <Badge>{this.state.totalItems}</Badge></h3>
                {/* <Button  variant="contained" size="medium" color="primary" onClick={this.export} style={{marginLeft: "10px"}}>Export</Button> */}
                {/* <div>
                    <form onSubmit={(e) => this.filterCriteria(e)} ref="searchForm">
                        <input ref="inputText" type="text" name="searchText" placeholder="Search" onChange={(e) => this.filterCriteria(e)} style={{width: "80%", marginBottom: "10px", marginRight: "10px", padding: "5px", borderColor:"red"}} autoComplete="off">
                        </input>
                        <Glyphicon glyph="remove" onClick={this.clearSearch} style={{marginRight: "20px"}}/>
                    </form>
                    <div className={classes.divider} />
                </div> */}
                <div className="container">
                    <p style={{color:"red", paddingLeft:"20px"}}>{message}</p>
                    { !message &&
                        <Paper className={this.props.classes.root} style={{width: "100%", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px"}}>
                            <Table className={classes.table}>
                                <EnhancedTableHead
                                    order={this.state.order}
                                    orderBy={this.state.orderBy}
                                    onRequestSort={this.sortBy}
                                    rows ={this.state.columns} />
                                <TableBody>
                                {this.state.current_rows}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={RowCountOptions}
                                component="div"
                                count={this.state.totalItems}
                                rowsPerPage={this.state.numItemsPerPage}
                                page={this.state.currentPageNumber}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                        </Paper>
                    }
                </div>
                <DialogMUI
                    disableBackdropClick
                    disableEscapeKeyDown
                    open={this.state.show}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">{this.state.new_project.id ? "Project Details" : "Create Project"}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <TextField
                                    id="name"
                                    label="Name"
                                    placeholder="Name"
                                    name="name"
                                    defaultValue={this.state.new_project.name}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    error={error_fields.name}
                                    fullWidth />
                                <TextField
                                    id="Description"
                                    label="Description"
                                    placeholder="Description"
                                    name="description"
                                    defaultValue={this.state.new_project.description}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    error={error_fields.description}
                                    fullWidth />
                                <TextField
                                    id="qty"
                                    label="Quantity"
                                    placeholder="Quantity"
                                    name="qty"
                                    defaultValue={this.state.new_project.qty}
                                    className={this.props.classes.textField}
                                    margin="normal"
                                    variant="outlined"
                                    onChange={this.handleChange}
                                    required
                                    fullWidth
                                    type="number"
                                    error={error_fields.qty}
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    />
                                <section>
                                <AutoCompleteSelection  
                                    placeHolder="Select Job Phases"
                                    onChange={this.handleJobActionChange}
                                    name="job_actions"
                                    error={error_fields.job_actions}
                                    value={this.state.new_project.job_actions.filter(j => toInt(j.status) !== -1).map(value => ({
                                            id: value.job_action_id,
                                            value: value.job_action_name,
                                            label: value.job_action_name,
                                            status: value.status
                                        }))}
                                    options={this.state.master_job_actions} />
                                </section>
                                <Grid container className={classes.grid} spacing={16}>
                                    <Grid item xs={12}>
                                        <Grid container className={classes.demo} justify="center" spacing={24}>
                                            <Grid key={1} item xs>
                                                <Typography variant="subtitle1" id="modal-title" style={{ lineHeight: '38px', textAlign: 'center'}}>
                                                    Items Needed
                                                </Typography>
                                            </Grid>
                                            <Grid key={2} item xs>
                                                <Button onClick={this.handleShowAddItemProject} color={error_fields.items? "secondary": "primary"} variant="contained" style={{float: "right"}}>
                                                    <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                                    Add Items
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider variant='middle'/>
                                <div style={{minHeight: "180px"}}>
                                <List className={this.props.classes.list}>                                    
                                    {this.state.item_rows}
                                </List>
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                                Close
                            </Button>
                            <Button onClick={this.createModifyproject} color="primary" autoFocus>
                                Save
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <DialogMUI
                    fullWidth={true}
                    maxWidth="xs"
                    TransitionComponent={Transition}
                    open={this.state.showItemsDialog}
                    onClose={this.handleCloseItemsDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title" style={{paddingTop: 5, paddingBottom: 0}}>
                            <Grid container className={classes.grid}>
                                <Grid item xs={12}>
                                    <Grid container className={classes.demo} justify="space-evenly">
                                        <Grid key={1} item xs={6}>
                                            <Typography variant="subtitle1" id="modal-title" style={{ lineHeight: '38px', textAlign: 'left', fontWeight: "bold"}}>
                                                Items
                                            </Typography>
                                        </Grid>
                                        <Grid key={2} item xs={6}>
                                        <Typography variant="subtitle1" id="modal-title" style={{ lineHeight: '38px', textAlign: 'right', fontWeight: "bold"}}>
                                                Qty
                                            </Typography>
                                        </Grid>
                                        <Grid key={3} item xs={12}>
                                            <Divider />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description" component={'span'}>
                                <Grid container className={classes.grid} spacing={8}>
                                    {this.state.item_dialog_details}
                                </Grid>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions  style={{paddingTop: 5, paddingBottom: 5}}>
                            <Button onClick={this.handleCloseItemsDialog} color="primary" autoFocus>
                                Close
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <DialogMUI
                    open={this.state.showAddItem}
                    onClose={this.handleCloseAddItemProject}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Select Item</DialogTitle>
                        <DialogContent>
                            <FormControl className={classes.formControl}  style={{minWidth: "300px"}}>
                                <Select
                                    native
                                    multiple
                                    value={this.state.new_project.items.filter(i => toInt(i.status) !== -1).map(i => i.item_id )}
                                    onChange={this.handleAddItemToProject}
                                    inputProps={{
                                    id: 'select-single-native',
                                    }}
                                    style={{width: '100%'}}
                                >
                                    {this.state.master_items.map(item => (
                                        this.state.new_project.items.filter((i) => i.item_id === item.id && toInt(i.status) === 1).length === 0 &&
                                        <option key={item.id} value={item.id}>
                                            {item.name}
                                        </option>
                                        )
                                    )}
                                </Select>
                                </FormControl>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseAddItemProject} color="primary">
                                Close
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <DialogMUI
                    open={this.state.showChangeStatus}
                    onClose={this.handleCloseChangeStatus}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    scroll='paper'>
                        <DialogTitle id="alert-dialog-title">Change Status</DialogTitle>
                        <DialogContent style={{minWidth: "300px"}}>
                            <Select
                                value={this.state.selected_project.status}
                                onChange={(e) => this.changeStatusForProject(e)}
                                input={
                                <OutlinedInput
                                    labelWidth={200}
                                    name="Status"
                                    id="outlined-status-simple"
                                />
                                }
                                style={{width: '100%'}}
                            >
                                <MenuItem value={"0"}>{convertProjectStatusToString("0")}</MenuItem>
                                <MenuItem value={"1"}>{convertProjectStatusToString("1")}</MenuItem>
                                <MenuItem value={"2"}>{convertProjectStatusToString("2")}</MenuItem>
                            </Select>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.handleCloseChangeStatus} color="primary">
                                Cancel
                            </Button>
                        </DialogActions>
                </DialogMUI>
                <Fab onClick={this.newProject} color="primary" aria-label="Add" className={this.props.classes.fab} style={{position: 'fixed', top: '85%', left: '90%'}}>
                    <AddIcon />
                </Fab>
            </div>
        );
    }

    getValidationStateName() {
        if(this.state.new_project.name){
            const length = this.state.new_project.name.length;
            if (length >= 3) return 'success';
            else return 'error';
        }
        return null;
    }
}

class ProjectDetails extends Component {

    render(){
      const project = this.props.project;
    //   const format = 'YYYY-MM-DD HH:mm:SS';
    //   const time = moment(location.time, format);
        // const items = project.items.reduce(function(items, item, idx) {
        //     return idx === 0 ? item.item_name : items + ', ' + item.item_name
        // }, '');
        const items = project.items.length;

        // const items_tooltip = project.items.reduce(function(items, item, idx) {
        //     return idx === 0 ? item.item_name + ": " + item.qty : items + ', ' + item.item_name + ": " + item.qty
        // }, '');

        const job_actions = project.job_actions.reduce(function(job_actions, job_action, idx) {
            return idx === 0 ? job_action.job_action_name : job_actions + ', ' + job_action.job_action_name
        }, '');

        return (
            <TableRow key={project.id}>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{project.name}</Typography>
                    <Typography variant="body1">({project.description})</Typography>
                </TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{project.qty}</Typography></TableCell>
                <TableCell align="center"  padding='none' onClick={(e) => this.props.changeStatus(e, project)}>
                    {getProjectStatusBadge(project.status)}
                </TableCell>
                <TableCell align="center"  padding='none'>
                    <Typography variant="subtitle1">{items}
                        <OverlayTrigger overlay={tooltip("View Items")}>
                            <Glyphicon style={{marginLeft: "10px", top: 3}} glyph="list-alt" onClick={(e) => this.props.showItemDetails(e, project)}/>
                        </OverlayTrigger>
                    </Typography>
                    
                    {/* <OverlayTrigger overlay={tooltip(items_tooltip)}>
                        <HelpIcon />
                    </OverlayTrigger> */}
                </TableCell>
                <TableCell align="center"  padding='none'>{job_actions}</TableCell>
                <TableCell align="center"  padding='none'>{getTimeInIST(project.created_date).format(format_display)}</TableCell>
                <TableCell align="center"  padding='none'>{project.created_by}</TableCell>
                {/* <TableCell align="center" >
                    
                </TableCell> */}
                <TableCell align="right"  padding='none'>
                    <OverlayTrigger overlay={tooltip("Edit Project")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="pencil" onClick={(e) => this.props.edit(e, project)}/>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={tooltip("Remove Project")}>
                        <Glyphicon style={{marginRight: "10px"}} glyph="trash" onClick={(e) => this.props.remove(e, project)}/>
                    </OverlayTrigger>
                </TableCell>
            </TableRow>
        );
    }
}

class ItemDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            error: toInt(this.props.item.qty || 0) <= 0,
            handleItemQtyChange: props.handleItemQtyChange
        }
    }


    handleChange = (e) => {
        this.state.handleItemQtyChange(e);
        if((toInt(e.target.value) || 0) <= 0){
            this.setState({error: true});
        } else {
            this.setState({error: false});
        }
    }

    render(){
      const item = this.props.item;
      const disabled = !this.props.master_items.filter(i => i.id === item.item_id).length;
        return (
            <ListItem key={item.item_id} role={undefined} dense button>
                <ListItemText primary={<Typography type="title">{item.item_name}</Typography>} style={{width: "30%"}}/>
                <TextField
                    id="standard-number"
                    label="Qty"
                    error={this.state.error}
                    defaultValue={item.qty}
                    onChange={this.handleChange}
                    type="number"
                    name={item.item_id}
                    InputLabelProps={{
                        shrink: true,
                        style: { zIndex: 'auto' }
                    }}
                    className={this.props.classes.qtyField}
                    margin="normal"
                    variant="outlined"
                    disabled={disabled}
                    helperText={disabled ? "This Item has been removed from the system": ""}
                />
                {/* <ListItemText primary={item.qty} style={{width: "30%"}}/> */}
                <ListItemSecondaryAction>
                    {/* <IconButton aria-label="Edit" onClick={(e) => this.props.editItem(e, item)} className={this.props.classes.icon}>
                        <EditIcon />
                    </IconButton> */}
                    <IconButton aria-label="Delete" onClick={(e) => this.props.removeItem(e, item)} className={this.props.classes.icon}>
                        <DeleteIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            </ListItem>
        );
    }
}

export default withStyles(styles)(Project);